// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Store Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackPriceListExportParameters extends TrackEventBaseParameters {}

const trackPriceListExport = (
    parameters: TrackPriceListExportParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "file_export", ...parameters }, options);
};

export default trackPriceListExport;
